import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../FoodTruck.module.scss';
import metadata from './BusinessInformationComponent.metadata.json5';

import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function BusinessInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BusinessInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        yeaOfExpOpeAFooTruFie: {
            visible: !_.isUndefined(modelVM.yeaInOpeFie.value) 
            && modelVM.yeaInOpeFie.value !== ""
            && modelVM.yeaInOpeFie.value < 3
        },
        pleIndTypOfFooProsFie: {
            visible: !_.isUndefined(modelVM.doYouProFooDelSerFie.value) && modelVM.doYouProFooDelSerFie.value === true
        },
        ifYesPleDesFie: {
            visible: !_.isUndefined(modelVM.doYouSelAnyProThaAFie.value) && modelVM.doYouSelAnyProThaAFie.value === true
        },
        ifYesPleDes2Fie: {
            visible: !_.isUndefined(modelVM.doeTheAppProAnySerFie.value) && modelVM.doeTheAppProAnySerFie.value === true
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

BusinessInformationComponent.propTypes = wizardProps;
export default withRouter(BusinessInformationComponent);
